import axios from 'axios';
import orderMixin from "../../mixins/orderMixin";

export default {
  namespaced: true,
  state: {
    powerpackPreferences: [],
  },


  mutations: {
    addToBuild(state, build) {
      let existing = state.powerpackPreferences.find((pref, index) => {
        return pref.pivot.name.toLowerCase() === build.pivot.name.toLowerCase();
      });

      if (existing) {
        state.powerpackPreferences.splice(state.powerpackPreferences.indexOf(existing), 1);
        state.powerpackPreferences.push(build);
      } else {
        state.powerpackPreferences.push(build);
      }
    },
    setCustomerPreferences(state, customerPreferences) {
      state.powerpackPreferences = customerPreferences
    },
  },

  actions: {
    availablePowerpackBuilds({commit}, customer) {
      return axios
        .get('/powerpack/builds', customer)
        .then(({data}) => {
          commit('setCustomerPreferences', data)
        })
    },
    savePowerpackPreferences({commit}, {buildName, build}) {
      return axios
        .post('/powerpack/builds/save', {buildName, build})
        .then(({data}) => {
          commit('addToBuild', data.build)
        })
    }
  },

  getters: {
    isLogged: state => !!state.user
  }
}
